






























import Vue from 'vue';
import { mapActions } from 'vuex';

import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';
import setStatus from '../mixins/setStatus';

export default Vue.extend({
  name: 'FinalizationCard',
  components: {
    GenericCard,
  },
  mixins: [setStatus],
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    showDurationWarning() {
      return this.unscopedIds.length > 50;
    },
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
    }),
    async finalizeAllObjects() {
      try {
        this.loading = true;

        // Set the program status to 'Final'
        this.setStatus('Final', this.program.id, this.program.__typename);

        // Set all unscoped object statuses to 'Not in Scope'
        const finalizeUnscoped = node => this.setStatus('Not in Scope', node.id, node.__typename);
        await Promise.all(this.unscopedIds.map(finalizeUnscoped));
        this.showAlert({
          type: 'success',
          message: 'Your Program was successfully finalized.',
        });
      } catch {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong. Your Program might not be finalized.',
        });
      } finally {
        this.loading = false;
        this.confirmModal();
      }
    },
  },
  apollo: {
    unscopedIds: {
      query: require('../queries/FinalizationData.gql'),
      variables() {
        return { programId: this.program.id };
      },
      update(result) {
        const getUnscoped = (objectType: string) =>
          result.node.mappings[objectType].edges
            .map(e => e.node)
            .filter(n => !['In Scope', 'Not in Scope'].includes(n.status.value));

        return [...getUnscoped('standards'), ...getUnscoped('sections'), ...getUnscoped('objectives')];
      },
    },
  },
});
